import { Component, AfterViewInit } from '@angular/core';
//import { AngularFire, FirebaseListObservable, FirebaseObjectObservable } from 'angularfire2';
import * as firebase from 'firebase';
import { MemberService } from './member.service';
import {DomSanitizer,SafeResourceUrl,} from '@angular/platform-browser';

import { Member } from './member';
declare var jQuery:any;

@Component({
  selector: 'member-journey',
  templateUrl: './journey.component.html'
})

export class JourneyComponent implements AfterViewInit {
	totalChapter = 0;
	warningMsg = '';
	currUserUid = '';
	memberProfile;
	chapterNum = 0;
	private sub: any;
	public s3ChapterParams = {
		Bucket: 'cefkid-journey',
		Delimiter: '/'
	};
	url:SafeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl("https://cefkid-journey.s3.amazonaws.com/chapter0/chapter0.html?reclen=0");;

	constructor(public sanitizer:DomSanitizer, private memberService: MemberService) {
		firebase.auth().onAuthStateChanged(user => {
			if (user) {
				this.memberService.s3.listObjectsV2(this.s3ChapterParams, (err, data) => {
					if (!err) {
						//console.log(data)
						if (data.CommonPrefixes.length) {
							this.totalChapter = data.CommonPrefixes.length-1;
						}
					} else {
						console.log(err);
					}
				});

				this.currUserUid = user.uid;
				//console.log(this.currUserUid);
				//this.currUserUid = 'fVEPM5dJXtffS1XVNLEbRJxFgR92';
				let db = firebase.database();
				db.ref('profile/'+this.currUserUid).once('value').then(
					(profile:any)=>{
						this.memberProfile = profile.val();
						db.ref('journeyRecords/'+this.currUserUid).once('value').then(
							(snapshot:any) => {
								let d = new Date();
								let t = d.getTime();
								let nextChapter = 1;
								let validDate = '';
								if (this.memberProfile.nextJourney !== undefined){
									if (this.memberProfile.nextJourney.chapter !== undefined) nextChapter = this.memberProfile.nextJourney.chapter;
									var vd = new Date(this.memberProfile.nextJourney.validDate);
									validDate = vd.getTime()+'';
								}
								if (snapshot.val()){
									this.chapterNum = snapshot.val().length-1; 
									//if (this.memberProfile.nextJourney.chapter!=undefined) {
									//	this.chapterNum = this.memberProfile.nextJourney.chapter-1; 
									//} else {
									//	this.chapterNum = 0;
									//}
									
								}
								if (this.memberProfile.level < 4) {
									this.chapterNum = this.totalChapter
									nextChapter = this.totalChapter
								}
								this.url = this.sanitizer.bypassSecurityTrustResourceUrl("https://cefkid-journey.s3.amazonaws.com/chapter0/chapter0.html?reclen="+this.chapterNum+"&nextChapter="+nextChapter+"&validDate="+validDate+"&t="+t);
								console.log("https://cefkid-journey.s3.amazonaws.com/chapter0/chapter0.html?reclen="+this.chapterNum+"&nextChapter="+nextChapter+"&validDate="+validDate+"&t="+t)
							}
						)
					}
				)
				
			}
		})
	}

	ngAfterViewInit(){
	}
}



// WEBPACK FOOTER //
// C:/Users/noomo/Desktop/project/newCefKid/cefapp2/src/app/member/journey.component.ts